import { Button, ButtonBase, IconButton, ListItemButton, MenuItem } from '@mui/material';
import { createLink } from '@tanstack/react-router';

export const ButtonLink = createLink(Button);
export const IconButtonLink = createLink(IconButton);
export const ButtonBaseLink = createLink(ButtonBase);
export const ListItemLink = createLink(ListItemButton);
export const MenuLinkItem = createLink(MenuItem);
export const ListItemButtonLink = createLink(ListItemButton);
